import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { capitalizeString, generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls, useRelations } from '@hooks/useNotification'

import type { NotificationModel } from '@models/types'

const NotificationListItem = (props: { notification: NotificationModel }) => {
  const {
    notification,
    notification: {
      audience, title,
    },
  } = props

  const { editNotificationUrl } = generateUrls(notification)
  const { agency, brand, provider } = useRelations(notification)

  const notifiableText = agency?.title || brand?.title || provider?.title || `All ${capitalizeString(audience)}`

  return (
    <DashboardModuleListItem
      href={`${editNotificationUrl}?redirect=${generateRedirectUrl()}`}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {audience === 'global' ? 'Global' : notifiableText}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default NotificationListItem
